'use client';

import React, { useEffect, useRef } from 'react';

const values = [
  {
    icon: '🏛️',
    title: 'Cultural Preservation',
    desc: 'Street alponas, real rituals, authentic craftsmanship, and sit-down bhog — every detail is crafted with cultural precision, not mass-produced spectacle.',
  },
  {
    icon: '🤝',
    title: 'Community Building',
    desc: 'Truly inclusive — Bengali, Marathi, Tamil, Marwari, Gujarati and more. A space where every hand contributes and every family belongs.',
  },
  {
    icon: '🎨',
    title: 'Artistic Excellence',
    desc: 'Each year, a new theme is explored with depth and intention. From Thakur Dalaan to Patachitra to Prathaa — always a living, evolving cultural statement.',
  },
  {
    icon: '👨‍👩‍👧',
    title: 'Children First',
    desc: 'A space where the next generation learns, grows into, and carries these traditions forward — not as museum pieces, but as lived experience.',
  },
];

export default function ValuesSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => { entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add('active'); }); },
      { threshold: 0.08 }
    );
    sectionRef?.current?.querySelectorAll('.reveal')?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="bg-muted/40 w-full px-4 md:px-12 pt-12 md:pt-16 pb-12 md:pb-16">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-12 reveal">
          <span className="inline-block px-4 py-1.5 rounded-full border border-border text-muted-foreground text-xs font-bold tracking-widest uppercase mb-4 md:mb-5">
            Our Values
          </span>
          <h2 className="font-display text-2xl md:text-3xl lg:text-4xl font-black text-foreground tracking-tight">
            What We Stand For
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
          {values?.map((v, i) => (
            <div
              key={v?.title}
              className="reveal bg-card border border-border rounded-2xl md:rounded-3xl p-6 md:p-8 hover:shadow-gold hover:-translate-y-0.5 transition-all duration-300"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <span className="text-2xl md:text-3xl block mb-3 md:mb-4">{v?.icon}</span>
              <h3 className="font-display text-lg md:text-xl font-black text-foreground tracking-tight mb-2 md:mb-3">{v?.title}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">{v?.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}